module.exports = __webpack_public_path__ + "media/images/badge/coppa-italia-vincente-f8181feaa4c0dd1dfd536856e557b681.png";